/* tslint:disable */
import {
  Department,
  Group
} from '../index';

declare var Object: any;
export interface ServiceoProblemReasonCodesInterface {
  "sfdcId"?: string;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "OwnerId"?: string;
  "Name"?: string;
  "Active__c"?: boolean;
  "Name__c"?: string;
  "PgMO_Departments__c"?: string;
  "PgMO_Groups__c"?: string;
  "Problem_Reason_Code__c"?: string;
  "Problem_Reason_Sub_Code__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  department?: Department;
  group?: Group;
}

export class ServiceoProblemReasonCodes implements ServiceoProblemReasonCodesInterface {
  "sfdcId": string;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "OwnerId": string;
  "Name": string;
  "Active__c": boolean;
  "Name__c": string;
  "PgMO_Departments__c": string;
  "PgMO_Groups__c": string;
  "Problem_Reason_Code__c": string;
  "Problem_Reason_Sub_Code__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  department: Department;
  group: Group;
  constructor(data?: ServiceoProblemReasonCodesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ServiceoProblemReasonCodes`.
   */
  public static getModelName() {
    return "ServiceoProblemReasonCodes";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ServiceoProblemReasonCodes for dynamic purposes.
  **/
  public static factory(data: ServiceoProblemReasonCodesInterface): ServiceoProblemReasonCodes{
    return new ServiceoProblemReasonCodes(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ServiceoProblemReasonCodes',
      plural: 'ServiceoProblemReasonCodes',
      path: 'ServiceoProblemReasonCodes',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "Active__c": {
          name: 'Active__c',
          type: 'boolean'
        },
        "Name__c": {
          name: 'Name__c',
          type: 'string'
        },
        "PgMO_Departments__c": {
          name: 'PgMO_Departments__c',
          type: 'string'
        },
        "PgMO_Groups__c": {
          name: 'PgMO_Groups__c',
          type: 'string'
        },
        "Problem_Reason_Code__c": {
          name: 'Problem_Reason_Code__c',
          type: 'string'
        },
        "Problem_Reason_Sub_Code__c": {
          name: 'Problem_Reason_Sub_Code__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        department: {
          name: 'department',
          type: 'Department',
          model: 'Department',
          relationType: 'belongsTo',
                  keyFrom: 'PgMO_Departments__c',
          keyTo: 'sfdcId'
        },
        group: {
          name: 'group',
          type: 'Group',
          model: 'Group',
          relationType: 'belongsTo',
                  keyFrom: 'PgMO_Groups__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
